import script from "./not.vue?vue&type=script&setup=true&lang=js"
export * from "./not.vue?vue&type=script&setup=true&lang=js"

import "./not.vue?vue&type=style&index=0&id=3bb37d08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bb37d08"]])

export default __exports__